import React from 'react';

import Grid from '@mui/material/Grid';

import useGlobalState from 'actions';

import loading from 'assets/loading_new.gif';

const LoadingOverlay = () => {
  const [state] = useGlobalState();

  return state.isLoadingOverlayShown ? (
    <Grid
      container
      spacing={0}
      alignItems='center'
      justifyContent='center'
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999999999,
        background: 'rgba(0,0,0,0.5)',
      }}
    >
      <Grid item xs={3}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={loading}
            alt='zoom'
            style={{ width: '100px', height: '100px' }}
          />
        </div>
      </Grid>
    </Grid>
  ) : null;
};

export default LoadingOverlay;
